import React, { useEffect, useState, useRef } from "react";

export const RecipeContext = React.createContext();

export const RecipeContextProvider = ({ children }) => {
  const [activeRecipe, setActiveRecipe] = useState(null);
  const [activeStepIndex, setActiveStepIndex] = useState(0);
  const [currentlyPlayingVideoIndex, setCurrentlyPlayingVideoIndex] =
    useState(null);

  const wakeLockRef = useRef(null);

  // If the recipe is active we want a Wake lock so that the screen doesn't go to sleep and then release it on return
  // if the recipe is not active, release the wake lock
  useEffect(() => {
    if (activeRecipe !== null) {
      if ("wakeLock" in navigator) {
        navigator.wakeLock
          .request("screen")
          .then((wl) => {
            wakeLockRef.current = wl;
            console.log("Activating wake lock");
          })
          .catch((err) => {
            console.log(`${err.name}, ${err.message}`);
          });
      } else {
        console.log("Wake lock not available");
      }
    } else {
      if (wakeLockRef.current) {
        console.log("Releasing wake lock");
        wakeLockRef.current.release();
      }
    }
  }, [activeRecipe]);

  const value = {
    activeRecipe,
    setActiveRecipe,
    activeStepIndex,
    setActiveStepIndex,
    currentlyPlayingVideoIndex,
    setCurrentlyPlayingVideoIndex,
  };
  return (
    <RecipeContext.Provider value={value}>{children}</RecipeContext.Provider>
  );
};
